module.exports = __webpack_public_path__ + "img/chat-square-fill.d6834f4f.svg";